// extracted by mini-css-extract-plugin
export var lg = "_jn-7";
export var md = "_jn-6";
export var placeholderContainer = "_jn-1";
export var placeholderIcon = "_jn-2";
export var productImage = "_jn-0";
export var sm = "_jn-5";
export var xl = "_jn-8";
export var xs = "_jn-4";
export var xxs = "_jn-3";